<div id="header">
  <mat-form-field>
    <mat-label>Recherche</mat-label>
    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Saisir la recherche">
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
  <mat-checkbox (change)="actif($event)" [checked]="inactif" class="ml-5" color="primary">
    Afficher les utilisateurs inactifs
  </mat-checkbox>
  <div id="button">
    <button *ngIf="isAdminSite" mat-raised-button color="primary" (click)="exportClientAccess()"
      [disabled]="isExportAccess || isExportUser">
      <mat-spinner diameter="20" *ngIf="isExportAccess"></mat-spinner>Export client access
    </button>
    <button mat-raised-button color="primary" (click)="export()" [disabled]="isExportAccess || isExportUser">
      <mat-spinner diameter="20" *ngIf="isExportUser"></mat-spinner>Export utilisateurs
    </button>
  </div>
</div>

<table mat-table [dataSource]="users">

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell *matCellDef="let user" class="list-actions-1">
      <mat-icon id="edit-button" matSuffix>edit</mat-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="username">
    <th mat-header-cell *matHeaderCellDef> Identifiant </th>
    <td mat-cell *matCellDef="let user"> {{user.username}} </td>
  </ng-container>

  <ng-container matColumnDef="lastname">
    <th mat-header-cell *matHeaderCellDef> Nom </th>
    <td mat-cell *matCellDef="let user"> {{user.lastname}} </td>
  </ng-container>

  <ng-container matColumnDef="firstname">
    <th mat-header-cell *matHeaderCellDef> Prénom </th>
    <td mat-cell *matCellDef="let user"> {{user.firstname}} </td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef> Email </th>
    <td mat-cell *matCellDef="let user"> {{user.email}} </td>
  </ng-container>

  <ng-container matColumnDef="phone">
    <th mat-header-cell *matHeaderCellDef> Téléphone </th>
    <td mat-cell *matCellDef="let user"> {{user.phone}} </td>
  </ng-container>

  <ng-container matColumnDef="lastLogin">
    <th mat-header-cell *matHeaderCellDef> Dernière connexion </th>
    <td mat-cell *matCellDef="let user"> {{user.last_login | date: 'dd/MM/yyyy HH:mm:ss': 'fr'}} </td>
  </ng-container>

  <ng-container matColumnDef="actif">
    <th mat-header-cell *matHeaderCellDef> Actif </th>
    <td mat-cell *matCellDef="let user"> <mat-icon *ngIf="user.enabled">check</mat-icon><mat-icon
        *ngIf="!user.enabled">close</mat-icon></td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let user; columns: displayedColumns;" (click)="editUser(user)"></tr>

</table>
<div [hidden]="users.data.length == 0">
  <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
</div>